import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, shareReplay, throwError } from 'rxjs';

import { environment } from '@/environments/environment';

import { AuthUtils } from '@authcore/auth.utils';
import { UserService } from '@authuser/user.service';
import { UserType } from '@authuser/user.types';

@Injectable({ providedIn: 'root' })
export class AuthService {
    get BASEURL(): string {
        return environment.api.replace("[hostinglocation]", AuthUtils.hostingLocation) + '/api/v2/';
    }

    private _authenticated: boolean = false;

    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService
    ) {
    }

    set refreshToken(token: string) {
        AuthUtils.refreshToken = token;
    }
    get refreshToken(): string {
        return AuthUtils.refreshToken;
    }

    set token(token: string) {
        AuthUtils.token = token;
    }
    get token(): string {
        return AuthUtils.token;
    }
    set instanceCode(instanceCode: string) {
        AuthUtils.instanceCode = instanceCode;
    }
    get instanceCode(): string {
        return AuthUtils.instanceCode;
    }

    check(): Observable<boolean> {
        // Check if the user is logged in
        if (this._authenticated) {
            return of(true);
        }

        // Check the access token availability
        if (!this.token) {
            return of(false);
        }

        // Check the access token expire date
        if (AuthUtils.isTokenExpired(this.token)) {
            return of(false);
        }

        return of(true);

        // If the access token exists, and it didn't expire, sign in using it
        //return this.signInUsingToken();
    }

    __t: any = null;
    __validate$?: Observable<UserType> = undefined;
    validate(nocache: boolean = false): Observable<UserType | null> {

        if (!AuthUtils.hostingLocation) {
          this.__validate$ = undefined;

          if (this.__t) clearTimeout(this.__t);

          return of(null);
        }

        if (nocache) {
            this.__validate$ = undefined;

            if (this.__t) clearTimeout(this.__t);
        }

        const t: number = 1000 * 60;
        if (this.__validate$ == undefined) {
            this.__validate$ = this._httpClient.post(`${this.BASEURL}account/validate`, {}, { headers: { 'content-type': 'application/x-www-form-urlencoded' } }).pipe(
                shareReplay(1, t),
                map((user: any) => {
                    if (user) {
                        localStorage.setItem('_ud', JSON.stringify(user));

                        const tz = (user?.timeZoneName.match(/\)\s*(\w+)/) ?? []);
                        localStorage.setItem('_timezonename', tz.length > 1 ? tz[1] : '');
                    }

                    this._userService.refreshCache(nocache);

                    return user;
                }),
                catchError(e => throwError(() => e))
            );

            this.__t = setTimeout(() => this.__validate$ = undefined, t);
        }

        return this.__validate$;
    }
}
